
import { Component, Prop, Vue } from "vue-property-decorator";
import anime from "animejs";

@Component
export default class Menu extends Vue {

  isMobile() {
      if( screen.width <= 760 ) {
          return true;
      }
      else {
          return false;
      }
  }

  mounted() {
    anime({
      targets: [".menu"],
      translateX: -400,
      direction: 'reverse',
      duration: 1000,
      color: 'rgba(0, 0, 0, 0)',
      easing: 'easeInOutSine',
      delay: 2000
    });
  }

}
